module.exports = __webpack_public_path__ + "static/niegolewskich-img-5-1a8ceacb30c361e34cbb9ffba0da27b5.jpg";